import { AutoMap } from "@automapper/classes"

export class MesureGeneric {
    @AutoMap()
    Code: string = ''
    @AutoMap()
    Name: string = ''
    @AutoMap()
    GroupName: string = ''
    @AutoMap()
    TestCode: string = ''
    @AutoMap()
    Reference: string = ''
    @AutoMap()
    IsCancelled: boolean = false
    @AutoMap()
    SamplingId?: number
    @AutoMap()
    InterventionId?: number
}